// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__Cc2vk","description":"styles_description__P8ErJ","discount":"styles_discount__ZcsNx"};